const formatTime = require('../../../../utils/formatTime');
const getDateRange = require('./getDateRange');

module.exports = (self) => {
  const filter = self.state.filter;
  const sort = self.state.sort;
  const {from, to} = getDateRange(filter);

  const dateMask = '{yyyy}-{mm}-{dd}';

  const result = {
    search: filter.search || null,
    from: from ? formatTime(from, dateMask) : null,
    to: to ? formatTime(to, dateMask) : null,
  };

  if (sort) {
    result['order_by'] = sort['name'];
    result['order_kind'] = sort['type'];
  }

  return result;
};
